import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { useUIService } from "../../../../../../../use-cases/ui";
import { useListaCboService } from "../../../../../../../use-cases/geo-veles/lista-cbo";
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { IListaCbo } from "../../../../../../../application/models/geo-veles/IListaCbo";

export const RecorteListasCbo = () => {
  // State
  const { listasCbo } = useAppSelector((state) => state.listaCbo);
  const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao);

  // Use State
  const [selectedListasCbo, setSelectedListasCbo] = useState<IListaCbo[]>([]);

  // Hooks
  const { setupListasCbo } = useListaCboService();
  const {
    syncFilterWithForm,
    removeFilterFromForm,
    resetSelectedFilter
  } = useRecortesExtracaoService();
  const { setAlert } = useUIService();

  // Sincroniza o estado local com o form
  useEffect(() => {
    const listasSelecionadasIds = createRecorteExtracaoForm.fields.Filtros?.listasCbo || [];

    if (listasSelecionadasIds.length > 0) {
      const listasCompletas = listasCbo.filter(lista =>
        listasSelecionadasIds.includes(lista.IdVelesGeoListaCBO)
      );
      setSelectedListasCbo(listasCompletas);
    } else {
      setSelectedListasCbo([]);
    }
  }, [createRecorteExtracaoForm.fields.Filtros?.listasCbo, listasCbo]);

  // Filtra as opções para remover os itens já selecionados
  const filteredListasCbo = listasCbo.filter((lista: IListaCbo) =>
    !selectedListasCbo.some((selected: IListaCbo) => selected.IdVelesGeoListaCBO === lista.IdVelesGeoListaCBO)
  );

  const handleListasCboSelectionChange = (value: IListaCbo[]) => {
    setSelectedListasCbo(value);

    if (value.length > 0) {
      syncFilterWithForm({
        filtro: 'listasCbo',
        value: value.map(lista => lista.IdVelesGeoListaCBO),
        formType: 'create'
      });
    } else {
      removeFilterFromForm({
        filtro: 'listasCbo',
        formType: 'create'
      });
    }
  };

  // Use Effects
  useEffect(() => {
    setupListasCbo();
  }, [setupListasCbo]);

  return (
    <>
      <Grid item xs={11} my={2}>
        <Autocomplete
          multiple
          id="listas-cbo-autocomplete"
          options={filteredListasCbo}
          getOptionLabel={(option: IListaCbo) => option.Nome?.toUpperCase() || ""}
          isOptionEqualToValue={(option: IListaCbo, value: IListaCbo) =>
            option.IdVelesGeoListaCBO === value.IdVelesGeoListaCBO
          }
          value={selectedListasCbo}
          onChange={(_, value: IListaCbo[]) => {
            handleListasCboSelectionChange(value);
          }}
          noOptionsText="Nenhuma lista de CBO encontrada"
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Listas de CBO" />
          )}
          sx={{ px: 2 }}
        />
      </Grid>
    </>
  );
};